let siteNavigation = document.getElementById('site-navigation');

// Toggle Main Menu + Change Aria-Status
let menuButton = document.getElementById('main-menu-button');

if(menuButton) {
    menuButton.addEventListener('click', () => {
        toggleMobileMenu(siteNavigation)
    })
}

function toggleMobileMenu(item) {
    if (item.ariaExpanded != "true") {
        item.classList.remove('hidden');
        item.ariaExpanded = "true"
    } else {
        item.classList.add('hidden');
        item.ariaExpanded = "false"
        
    }
}

// Move main-container down when menu opens

function moveMainElement(element) {

    let mainContainer = document.getElementsByTagName('main')[0];
    if(mainContainer.offsetWidth >= 1024) {
        mainContainer.style.transform = `translateY(${element}px)`;
    }
}

// Toggle Submenu + Change Aria-Status + Set .active class on button

let activeSubmenu;
let activeButton

function toggleSubMenu(menu, button) {

    if(activeSubmenu == menu) {
        activeSubmenu.classList.add('hidden');
        activeButton.classList.remove('active');
        activeSubmenu.ariaExpanded = false;
        activeSubmenu = null;
        activeButton = null;
        moveMainElement(0);
        return
    } 
    else if(activeSubmenu != null && activeSubmenu != menu) 
    {
        activeSubmenu.classList.add('hidden');
        activeButton.classList.remove('active');
        activeSubmenu.ariaExpanded = false;
    }
    
    menu.classList.remove('hidden');
    menu.ariaExpanded = true;
    button.classList.add('active')
    activeSubmenu = menu;
    activeButton = button

    moveMainElement(activeSubmenu.offsetHeight);
}


// Toggle Sub-Menu 
let subMenuButtons = siteNavigation.querySelectorAll('button');

if(subMenuButtons) {
    subMenuButtons.forEach((subMenuButton) => {
        subMenuButton.addEventListener('click', () => {
            toggleSubMenu(subMenuButton.nextElementSibling, event.target)
            changeColor(subMenuButton.nextElementSibling)
        })
    })
}

// Farbe des Menüs der jeweiligen Seite anpassen
let newColor = document.getElementById('hero').style.backgroundColor;

function changeColor(item) {
    item.style.backgroundColor = newColor;
}

let pageHeader = document.getElementById('header');
if (pageHeader) {
    changeColor(pageHeader)
    changeColor(siteNavigation)
}